import { HttpParams } from '@angular/common/http';
import { Service } from '@angular/core';
import { map, Observable } from 'rxjs';
import { KalaApiResponse } from '../models/kala-api.model';
import { TradeResponseDto } from '../models/trade-response.model';
import { BaseService } from './base.service';

/**
 * Kala reports business failures as `200 OK` with `isSuccessful: false`, so the
 * envelope — not the HTTP status — decides whether a call actually worked.
 */
@Service()
export class TradesService extends BaseService {
	/**
	 * The executions that make up one order, newest state of the breakdown the detail
	 * sheet renders under «ریز معاملات».
	 *
	 * `symbol` and `orderDate` are optional narrowing hints the endpoint accepts; they are
	 * only sent when a caller has them, since the order id alone identifies the order.
	 */
	getTrades(orderId: number, symbol: string, orderDate: string): Observable<TradeResponseDto[]> {
		let params = new HttpParams();
		params = params.set('symbol', symbol);
		params = params.set('orderDate', orderDate);

		return this.http
			.get<KalaApiResponse<TradeResponseDto[]>>(`${this.kalaApiPath}/trades/${orderId}`, { params })
			.pipe(
				map(response => {
					if (!response.isSuccessful) {
						throw new Error(response.error?.message ?? 'دریافت ریز معاملات انجام نشد');
					}

					return response.data ?? [];
				})
			);
	}
}
